(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3956],{

/***/ 32553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* reexport */ SelectorButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/atomic/SelectorButton/selector-button.module.scss
var selector_button_module = __webpack_require__(79197);
var selector_button_module_default = /*#__PURE__*/__webpack_require__.n(selector_button_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/styleguide/LocoScore/index.ts + 1 modules
var LocoScore = __webpack_require__(27838);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/utilities/search.js
var search = __webpack_require__(45425);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var system = __webpack_require__(70591);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
;// CONCATENATED MODULE: ./components/atomic/SelectorButton/SelectorButton.js








var SelectorButton = function(param) {
    var onChangeParameter = param.onChangeParameter, filter = param.filter, filterValue = param.filterValue, activeValue = param.activeValue, availableFilters = param.availableFilters;
    var ref = (0,react.useState)(null), isAvailable = ref[0], setIsAvailable = ref[1];
    (0,react.useEffect)(function() {
        var available = (0,vehicle/* isLeaseProfileOptionAvailable */.nu)(availableFilters, "".concat(filter === constants/* LEASE_PROFILE_FILTER_INITIAL_PAYMENT_IN_MONTHS */.BE || filter === constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt ? filter : "".concat(filter, "s")), filterValue);
        setIsAvailable(available);
    }, [
        availableFilters,
        filter,
        filterValue
    ]);
    var isActive = activeValue === filterValue;
    var vehiclePrice = isAvailable ? availableFilters["available".concat((0,search/* capitaliseFirstLetter */.zd)(filter === constants/* LEASE_PROFILE_FILTER_INITIAL_PAYMENT_IN_MONTHS */.BE || filter === constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt ? filter : "".concat(filter, "s")))].filter(function(object) {
        return object[filter] === filterValue;
    })[0] : null;
    var displayPrice = vehiclePrice ? vehiclePrice.leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,search/* addVatToPrice */.QR)(vehiclePrice.monthlyPayment) : vehiclePrice.monthlyPayment : 0;
    var initialPayment = vehiclePrice ? vehiclePrice.leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,search/* addVatToPrice */.QR)(vehiclePrice.initialPaymentInMonths * vehiclePrice.monthlyPayment) : vehiclePrice.initialPaymentInMonths * vehiclePrice.monthlyPayment : 0;
    var getAvailableValuesForFilter = function() {
        return availableFilters["available".concat((0,search/* capitaliseFirstLetter */.zd)(filter === constants/* LEASE_PROFILE_FILTER_INITIAL_PAYMENT_IN_MONTHS */.BE || filter === constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt ? filter : "".concat(filter, "s")))] || null;
    };
    var getPriceDifferenceBetweenValueAndActiveValue = function(price) {
        var difference = 0;
        var activeVehiclePrice = null;
        var availableValuesForFilter = getAvailableValuesForFilter();
        if (availableValuesForFilter) {
            activeVehiclePrice = availableValuesForFilter.filter(function(object) {
                return object[filter] === activeValue;
            })[0];
        }
        if (activeVehiclePrice) {
            var activeDisplayPrice = activeVehiclePrice.leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,search/* addVatToPrice */.QR)(activeVehiclePrice.monthlyPayment) : activeVehiclePrice.monthlyPayment;
            difference = price - activeDisplayPrice;
        }
        return difference;
    };
    var getFormattedDifference = function(difference) {
        return Math.sign(difference) >= 0 ? "+ ".concat((0,search/* formatPrice */.T4)(difference)) : "- ".concat((0,search/* formatPrice */.T4)(Math.abs(difference)));
    };
    var getLabelForFilterValue = function(value) {
        if (filter === constants/* LEASE_PROFILE_FILTER_INITIAL_PAYMENT_IN_MONTHS */.BE) {
            return "".concat(value, " month").concat(value === 1 ? "" : "s");
        }
        if (filter === constants/* LEASE_PROFILE_FILTER_TERMS */.m$) {
            return "".concat(value >= 24 ? "".concat((0,search/* getTermsAsYearsName */.B5)(value), " years") : "".concat(value, " months"));
        }
        if (filter === constants/* LEASE_PROFILE_FILTER_MILEAGES */.zK) {
            return (0,search/* formatWithCommas */.b1)(value);
        }
        if (filter === constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt) {
            return value > 0 ? "In stock" : "Factory order";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        type: "button",
        onClick: function() {
            return onChangeParameter(filter, filterValue);
        },
        disabled: !isAvailable,
        "data-active": !!isActive,
        className: "".concat((selector_button_module_default())["large-button"], " ").concat(isActive ? (selector_button_module_default()).active : "").concat(!(0,system/* isProd */.BB)() ? " config-selector__".concat(filter, "-button--").concat(filterValue) : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (selector_button_module_default()).score,
                children: isAvailable && (vehiclePrice === null || vehiclePrice === void 0 ? void 0 : vehiclePrice.rating) != null && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocoScore/* LocoScore */.o, {
                    rating: vehiclePrice.rating,
                    iconOnly: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: getLabelForFilterValue(filterValue)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (selector_button_module_default())["small-text"],
                    children: isAvailable ? filter === constants/* LEASE_PROFILE_FILTER_INITIAL_PAYMENT_IN_MONTHS */.BE ? (0,search/* formatPrice */.T4)(initialPayment) : isActive ? "".concat((0,search/* formatPrice */.T4)(displayPrice), "/pm") : "".concat(getFormattedDifference(getPriceDifferenceBetweenValueAndActiveValue(displayPrice)), "/pm") : "Unavailable"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/atomic/SelectorButton/index.js



/***/ }),

/***/ 27838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ LocoScore; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/styleguide/LocoScore/loco-score.module.scss
var loco_score_module = __webpack_require__(53644);
var loco_score_module_default = /*#__PURE__*/__webpack_require__.n(loco_score_module);
;// CONCATENATED MODULE: ./components/styleguide/LocoScore/LocoScore.tsx



var LocoScore = function(param) {
    var rating = param.rating, _className = param.className, className = _className === void 0 ? "" : _className, _iconOnly = param.iconOnly, iconOnly = _iconOnly === void 0 ? false : _iconOnly, _isInline = param.isInline, isInline = _isInline === void 0 ? false : _isInline;
    var ref = (0,react.useState)("0, 100"), strokeDasharray = ref[0], setStrokeDasharray = ref[1];
    var ref1 = (0,react.useState)("#FFCC00"), colour = ref1[0], setColour = ref1[1];
    var ref2 = (0,react.useState)(0), currentRating = ref2[0], setCurrentRating = ref2[1];
    var PERFECT_SCORE = 73;
    (0,react.useEffect)(function() {
        // Setting up the dynamic keyframe end value when the component mounts or `rating` changes
        if (currentRating !== rating) {
            var animationCSS = "".concat(rating / 100 * PERFECT_SCORE, ", 100");
            var animation = setTimeout(function() {
                setStrokeDasharray(animationCSS);
                setColour(rating >= 80 ? "#FF2D55" : rating > 70 ? "#F15A24" : "#FFCC00");
                setCurrentRating(rating);
            }, 5);
            return function() {
                clearTimeout(animation);
            };
        }
    }, [
        currentRating,
        rating
    ]);
    var getDescriptionFromRating = function() {
        if (rating >= 90) {
            return "Amazing value";
        } else if (rating >= 80) {
            return "Great value";
        } else if (rating >= 70) {
            return "Fair value";
        } else {
            return "Low value";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((loco_score_module_default()).container, " ").concat(className),
        "data-is-inline": isInline,
        "data-icon-only": iconOnly,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                style: {
                    position: "relative",
                    display: "grid",
                    placeItems: "center",
                    height: 34,
                    width: 34
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "34",
                        height: "30",
                        viewBox: "0 0 34 30",
                        fill: "none",
                        className: (loco_score_module_default()).ring,
                        style: {
                            position: "absolute",
                            inset: 0,
                            zIndex: 4
                        },
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6.5 28C3.60451 25.1157 1.5 21.5 1.5 17C1.5 9 8.78728 1.5 17 1.5C25.2127 1.5 32.2701 8.94483 32.4028 17.3729C32.3374 21.3134 30.7773 24.992 27.5 28",
                            stroke: colour,
                            style: {
                                strokeDasharray: strokeDasharray
                            },
                            strokeLinecap: "round",
                            strokeWidth: "3"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "34",
                        height: "30",
                        viewBox: "0 0 34 30",
                        fill: "none",
                        style: {
                            position: "absolute",
                            inset: 0,
                            zIndex: 0
                        },
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6.5 28C3.60451 25.1157 1.5 21.5 1.5 17C1.5 9 8.78728 1.5 17 1.5C25.2127 1.5 32.2701 8.94483 32.4028 17.3729C32.3374 21.3134 30.7773 24.992 27.5 28",
                            stroke: "#E5E5EA",
                            strokeLinecap: "round",
                            strokeWidth: "3"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (loco_score_module_default()).score,
                        style: {
                            color: colour
                        },
                        children: rating
                    }),
                    rating > 90 && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "14",
                        height: "13",
                        viewBox: "0 0 14 13",
                        fill: "none",
                        className: (loco_score_module_default()).flame,
                        style: {
                            position: "absolute",
                            bottom: 0
                        },
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5.19652 8.10588C5.53809 8.10588 5.86567 7.9702 6.10719 7.72867C6.34872 7.48715 6.4844 7.15957 6.4844 6.818C6.4844 6.1071 6.22683 5.7877 5.96925 5.27255C5.41701 4.16858 5.85386 3.18413 6.99955 2.18164C7.25713 3.46952 8.02986 4.70588 9.06016 5.53013C10.0905 6.35437 10.6056 7.33316 10.6056 8.36346C10.6056 8.83701 10.5123 9.30593 10.3311 9.74344C10.1499 10.1809 9.88428 10.5785 9.54942 10.9133C9.21457 11.2482 8.81704 11.5138 8.37953 11.695C7.94203 11.8762 7.47311 11.9695 6.99955 11.9695C6.526 11.9695 6.05708 11.8762 5.61957 11.695C5.18207 11.5138 4.78454 11.2482 4.44968 10.9133C4.11483 10.5785 3.84921 10.1809 3.66799 9.74344C3.48677 9.30593 3.39349 8.83701 3.39349 8.36346C3.39349 7.76949 3.61655 7.1817 3.90865 6.818C3.90865 7.15957 4.04433 7.48715 4.28586 7.72867C4.52738 7.9702 4.85496 8.10588 5.19652 8.10588Z",
                            fill: "#FF2D55"
                        })
                    })
                ]
            }),
            !iconOnly && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (loco_score_module_default()).text,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (loco_score_module_default()).title,
                        children: "LocoScore"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (loco_score_module_default()).description,
                        children: getDescriptionFromRating()
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/LocoScore/index.ts



/***/ }),

/***/ 52733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ VehicleImage; },
  "C": function() { return /* reexport */ VehicleImageWithGallery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/styleguide/VehicleImage/vehicle-image.module.scss
var vehicle_image_module = __webpack_require__(80001);
var vehicle_image_module_default = /*#__PURE__*/__webpack_require__.n(vehicle_image_module);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
;// CONCATENATED MODULE: ./components/styleguide/VehicleImage/VehicleImage.tsx




var VehicleImage = function(param) {
    var alt = param.alt, height = param.height, width = param.width, imagePath = param.imagePath, backupImagePath = param.backupImagePath, _priority = param.priority, priority = _priority === void 0 ? false : _priority, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality, _layout = param.layout, layout = _layout === void 0 ? undefined : _layout, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = param.blurDataURL, _className = param.className, className = _className === void 0 ? "" : _className, _type = param.type, type = _type === void 0 ? "DEFAULT" : _type, _unoptimized = param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "\n        ".concat(type !== "GALLERY" && type !== "BROWSE" && type !== "HOMEPAGE" && imagePath ? (vehicle_image_module_default())["reverse-image"] : "", " ").concat(!imagePath ? (vehicle_image_module_default())["padded-image"] : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: imagePath ? (0,vehicle/* getGalleryImage */.Dq)(imagePath) : (0,vehicle/* getVehicleHeroImage */.Nk)(backupImagePath),
            alt: alt,
            height: height,
            width: width,
            priority: priority,
            quality: quality,
            layout: layout,
            placeholder: placeholder,
            blurDataURL: blurDataURL,
            className: className,
            unoptimized: unoptimized
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/VehicleImage/VehicleImageWithGallery.tsx








var VehicleImageWithGallery = function(param) {
    var alt = param.alt, height = param.height, width = param.width, images = param.images, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality, _layout = param.layout, layout = _layout === void 0 ? undefined : _layout, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? undefined : _placeholder, blurDataURL = param.blurDataURL, _className = param.className, className = _className === void 0 ? "" : _className, _unoptimized = param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _type = param.type, type = _type === void 0 ? "DEFAULT" : _type, _showDots = param.showDots, showDots = _showDots === void 0 ? true : _showDots, _alignDots = param.alignDots, alignDots = _alignDots === void 0 ? "center" : _alignDots, onChangeIndex = param.onChangeIndex;
    var ref = (0,react.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var ref1 = (0,react.useRef)(null);
    var onChangeCurrentIndex = function(index) {
        if (onChangeIndex) {
            onChangeIndex(index);
        }
        setCurrentIndex(index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (vehicle_image_module_default()).wrapper,
        "data-type": type,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref1,
                className: (vehicle_image_module_default()).carousel,
                onScroll: function(e) {
                    var target = e.target;
                    var calculation = Math.floor(target.scrollLeft / target.children[0].clientWidth);
                    onChangeCurrentIndex(calculation < 0 ? 0 : calculation);
                },
                children: images.filter(function(image) {
                    return image.angleType === "EXTERIOR";
                }).sort(function(a) {
                    return a.angle === "lowaggressive" ? -1 : 1;
                }).map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                        triggerOnce: true,
                        duration: 1000,
                        className: (vehicle_image_module_default()).item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-index": index,
                            className: "".concat((vehicle_image_module_default()).content, " ").concat(type !== "GALLERY" && type !== "BROWSE" && type !== "HOMEPAGE" && image.path ? (vehicle_image_module_default())["reverse-image"] : "", " ").concat(type === "SPEC" ? (vehicle_image_module_default())["spec-image"] : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (0,vehicle/* getGalleryImage */.Dq)(image.path),
                                alt: alt,
                                height: height,
                                width: width,
                                quality: quality,
                                layout: layout,
                                placeholder: placeholder,
                                blurDataURL: blurDataURL,
                                className: className,
                                unoptimized: unoptimized
                            })
                        })
                    }, image.id);
                })
            }),
            showDots && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (vehicle_image_module_default()).dots,
                "data-alignment": alignDots,
                children: images.filter(function(image) {
                    return image.angleType === "EXTERIOR";
                }).sort(function(a) {
                    return a.angle === "lowaggressive" ? -1 : 1;
                }).map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "".concat((vehicle_image_module_default()).dot).concat(currentIndex === index ? " " + (vehicle_image_module_default()).active : "").concat(Math.abs(currentIndex - index) > 2 ? Math.abs(currentIndex - index) >= 4 ? " " + (vehicle_image_module_default())["too-far"] : " " + (vehicle_image_module_default()).far : Math.abs(currentIndex - index) > 1 ? " " + (vehicle_image_module_default()).close : "")
                    }, image.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (vehicle_image_module_default()).arrows,
                "data-navigation-position": currentIndex === 0 ? "start" : currentIndex === images.filter(function(image) {
                    return image.angleType === "EXTERIOR";
                }).sort(function(a) {
                    return a.angle === "lowaggressive" ? -1 : 1;
                }).length - 1 ? "end" : "middle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: function() {
                            var ref, ref2, ref3;
                            ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                                left: ref1.current.scrollLeft - ((ref3 = ref1 === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.children[0]) === null || ref3 === void 0 ? void 0 : ref3.clientWidth),
                                behavior: "smooth"
                            });
                        },
                        icon: "ChevronLeft",
                        size: system/* Size.ExtraSmall */.$u.ExtraSmall,
                        hierarchy: type === "SPEC" ? Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray : Button/* ButtonHierarchy.Filled */.B.Filled,
                        theme: type === "SPEC" ? system/* Theme.light */.Q2.light : system/* Theme.dark */.Q2.dark
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: function() {
                            var ref, ref2, ref3;
                            ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                                left: ref1.current.scrollLeft + ((ref3 = ref1 === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.children[0]) === null || ref3 === void 0 ? void 0 : ref3.clientWidth),
                                behavior: "smooth"
                            });
                        },
                        theme: type === "SPEC" ? system/* Theme.light */.Q2.light : system/* Theme.dark */.Q2.dark,
                        icon: "ChevronRight",
                        size: system/* Size.ExtraSmall */.$u.ExtraSmall,
                        hierarchy: type === "SPEC" ? Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray : Button/* ButtonHierarchy.Filled */.B.Filled
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/VehicleImage/index.ts




/***/ }),

/***/ 31699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* reexport */ ProfileEditor; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-animate-height/dist/esm/index.js
var esm = __webpack_require__(29244);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./components/atomic/SelectorButton/index.js + 1 modules
var SelectorButton = __webpack_require__(32553);
// EXTERNAL MODULE: ./components/views/ProfileEditor/profile-editor.module.scss
var profile_editor_module = __webpack_require__(26449);
var profile_editor_module_default = /*#__PURE__*/__webpack_require__.n(profile_editor_module);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
;// CONCATENATED MODULE: ./components/views/ProfileEditor/InitialPaymentInMonths.js




var InitialPaymentInMonths = function(param) {
    var initialPaymentInMonths = param.initialPaymentInMonths, availableFilters = param.availableFilters, onChangeInitialPayment = param.onChangeInitialPayment;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (profile_editor_module_default()).section,
        "data-filter": "initial-payment-in-months",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Upfront payment"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((profile_editor_module_default())["scroll-area"], " carousel__container"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (profile_editor_module_default())["scroll-group"],
                    children: constants/* LEASE_PROFILE_FILTER_INITIAL_PAYMENT_IN_MONTHS_VALUES.map */.Ku.map(function(value) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorButton/* SelectorButton */.P, {
                            onChangeParameter: onChangeInitialPayment,
                            filter: constants/* LEASE_PROFILE_FILTER_INITIAL_PAYMENT_IN_MONTHS */.BE,
                            filterValue: value,
                            activeValue: initialPaymentInMonths,
                            availableFilters: availableFilters
                        }, value);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/views/ProfileEditor/Terms.js




var Terms = function(param) {
    var term = param.term, availableFilters = param.availableFilters, onChangeTerm = param.onChangeTerm;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (profile_editor_module_default()).section,
        "data-filter": "terms",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Lease term"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((profile_editor_module_default())["scroll-area"], " carousel__container"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (profile_editor_module_default())["scroll-group"],
                    children: constants/* LEASE_PROFILE_FILTER_TERMS_VALUES.map */.Uc.map(function(value) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorButton/* SelectorButton */.P, {
                            onChangeParameter: onChangeTerm,
                            filter: constants/* LEASE_PROFILE_FILTER_TERMS */.m$,
                            filterValue: value,
                            activeValue: term,
                            availableFilters: availableFilters
                        }, value);
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./lib/hooks/useExperiment.ts
var useExperiment = __webpack_require__(46389);
// EXTERNAL MODULE: ./lib/utilities/search.js
var search = __webpack_require__(45425);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var system = __webpack_require__(70591);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./store/actions/event.js
var actions_event = __webpack_require__(61748);
// EXTERNAL MODULE: ./store/reducers/leaseProfile.js
var reducers_leaseProfile = __webpack_require__(1093);
// EXTERNAL MODULE: ./store/selectors/leaseProfile.js
var selectors_leaseProfile = __webpack_require__(5958);
// EXTERNAL MODULE: ./types/system.ts
var types_system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/views/ProfileEditor/ProfileEditor.js




















var ProfileEditor = function(param) {
    var leaseProfile = param.leaseProfile, vehicleType = param.vehicleType, setHasLeaseProfileChanged = param.setHasLeaseProfileChanged, openSelectorOverride = param.openSelectorOverride, setOpenSelectorOverride = param.setOpenSelectorOverride, _context = param.context, context = _context === void 0 ? "config" : _context;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useExperiment/* useExperiment */.a)(), 1), experimentGroup = ref[0];
    var availableFilters = (0,es/* useSelector */.v9)(selectors_leaseProfile/* selectAvailableLeaseProfileFilters */.o);
    var ref1 = (0,react.useState)(""), openSelector = ref1[0], setOpenSelector = ref1[1];
    var ref2 = (0,react.useState)(leaseProfile.term), term = ref2[0], setTerm = ref2[1];
    var ref3 = (0,react.useState)(leaseProfile.mileage), mileage = ref3[0], setMileage = ref3[1];
    var ref4 = (0,react.useState)(leaseProfile.leaseType), leaseType = ref4[0], setLeaseType = ref4[1];
    var ref5 = (0,react.useState)(leaseProfile.stockStatus), stockStatus = ref5[0], setStockStatus = ref5[1];
    var ref6 = (0,react.useState)(leaseProfile.initialPaymentInMonths), initialPaymentInMonths = ref6[0], setInitialPaymentInMonths = ref6[1];
    var isMobile = (0,react_responsive.useMediaQuery)({
        maxWidth: 991
    });
    var ref7 = (0,react.useState)("control"), version = ref7[0], setVersion = ref7[1];
    (0,react.useEffect)(function() {
        if (experimentGroup.startsWith("edit-lease-placement-variant") && context === "config") {
            setVersion(experimentGroup.split("edit-lease-placement-")[1]);
        }
    }, [
        experimentGroup,
        context
    ]);
    (0,react.useEffect)(function() {
        if (isMobile && (openSelector !== "" || openSelectorOverride !== "")) {
            setOpenSelector("");
            if (setOpenSelectorOverride) {
                setOpenSelectorOverride("");
            }
        }
    }, [
        isMobile,
        openSelector,
        openSelectorOverride,
        setOpenSelectorOverride
    ]);
    (0,react.useEffect)(function() {
        if (openSelector !== "") {
            (0,vehicle/* addToDataLayer */.Bk)({
                event: "modal-view",
                modal: "/profile-editor"
            });
        }
    }, [
        openSelector
    ]);
    (0,react.useEffect)(function() {
        if (leaseProfile) {
            setTerm(leaseProfile.term);
            setMileage(leaseProfile.mileage);
            setLeaseType(leaseProfile.leaseType);
            setStockStatus(leaseProfile.stockStatus);
            setInitialPaymentInMonths(leaseProfile.initialPaymentInMonths);
        }
    }, [
        leaseProfile
    ]);
    var newLeaseProfile = function(filter, filterLabel) {
        switch(filter){
            case constants/* LEASE_PROFILE_FILTER_LEASE_TYPE */.Rb:
                return {
                    leaseType: filterLabel,
                    term: leaseProfile.term,
                    mileage: leaseProfile.mileage,
                    initialPaymentInMonths: leaseProfile.initialPaymentInMonths,
                    stockStatus: leaseProfile.stockStatus,
                    vehicleId: leaseProfile.vehicleId
                };
            case constants/* LEASE_PROFILE_FILTER_TERMS */.m$:
                return {
                    leaseType: leaseProfile.leaseType,
                    term: filterLabel,
                    mileage: leaseProfile.mileage,
                    initialPaymentInMonths: leaseProfile.initialPaymentInMonths,
                    stockStatus: leaseProfile.stockStatus,
                    vehicleId: leaseProfile.vehicleId
                };
            case constants/* LEASE_PROFILE_FILTER_MILEAGES */.zK:
                return {
                    leaseType: leaseProfile.leaseType,
                    term: leaseProfile.term,
                    mileage: filterLabel,
                    initialPaymentInMonths: leaseProfile.initialPaymentInMonths,
                    stockStatus: leaseProfile.stockStatus,
                    vehicleId: leaseProfile.vehicleId
                };
            case constants/* LEASE_PROFILE_FILTER_INITIAL_PAYMENT_IN_MONTHS */.BE:
                return {
                    leaseType: leaseProfile.leaseType,
                    term: leaseProfile.term,
                    mileage: leaseProfile.mileage,
                    initialPaymentInMonths: filterLabel,
                    stockStatus: leaseProfile.stockStatus,
                    vehicleId: leaseProfile.vehicleId
                };
            case constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt:
                return {
                    leaseType: leaseProfile.leaseType,
                    term: leaseProfile.term,
                    mileage: leaseProfile.mileage,
                    initialPaymentInMonths: leaseProfile.initialPaymentInMonths,
                    stockStatus: filterLabel,
                    vehicleId: leaseProfile.vehicleId
                };
            default:
                return {
                    leaseType: leaseProfile.leaseType,
                    term: leaseProfile.term,
                    mileage: leaseProfile.mileage,
                    initialPaymentInMonths: leaseProfile.initialPaymentInMonths,
                    stockStatus: leaseProfile.stockStatus,
                    vehicleId: leaseProfile.vehicleId
                };
        }
    };
    var onChangeParameter = function(filter, filterLabel) {
        var profile = newLeaseProfile(filter, filterLabel);
        dispatch((0,reducers_leaseProfile/* storeActiveLeaseProfile */.pu)(profile));
        var event = {
            event: "lease-profile-filter",
            "filter-event": "change-filter",
            "filter-category": filter,
            "filter-label": filterLabel,
            experimentGroup: experimentGroup
        };
        (0,vehicle/* addToDataLayer */.Bk)(event);
        dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
            event: constants/* constants.eventTypes.leaseProfileFilter */._G.eventTypes.leaseProfileFilter,
            payload: {
                "filter-event": "change-filter",
                "filter-category": filter,
                "filter-label": filterLabel
            }
        }));
        if (setHasLeaseProfileChanged) {
            setHasLeaseProfileChanged(true);
        }
    };
    var closeSelector = function() {
        setOpenSelector("");
        if (setOpenSelectorOverride) {
            setOpenSelectorOverride("");
        }
    };
    var onChangeMileage = function(filter, filterLabel) {
        setMileage(filterLabel);
        onChangeParameter(filter, filterLabel);
    };
    var onChangeTerm = function(filter, filterLabel) {
        setTerm(filterLabel);
        onChangeParameter(filter, filterLabel);
    };
    var onChangeInitialPayment = function(filter, filterLabel) {
        setInitialPaymentInMonths(filterLabel);
        onChangeParameter(filter, filterLabel);
    };
    var onToggleSelector = function(type) {
        if (openSelector === type || openSelectorOverride === type) {
            setOpenSelector("");
            if (setOpenSelectorOverride) {
                setOpenSelectorOverride("");
            }
            document.querySelector("header").classList.remove("overlay-open");
        } else {
            setOpenSelector(type);
            if (setOpenSelectorOverride) {
                setOpenSelectorOverride(type);
            }
            document.querySelector("header").classList.add("overlay-open");
        }
    };
    var onToggleEdit = function() {
        if (openSelector || openSelectorOverride) {
            setOpenSelector("");
            if (setOpenSelectorOverride) {
                setOpenSelectorOverride("");
            }
            document.querySelector("header").classList.remove("overlay-open");
            (0,vehicle/* addToDataLayer */.Bk)({
                event: "lease-profile-filter",
                "filter-event": "close",
                experimentGroup: experimentGroup
            });
            dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
                event: constants/* constants.eventTypes.leaseProfileFilter */._G.eventTypes.leaseProfileFilter,
                payload: {
                    "filter-event": "close"
                }
            }));
        } else {
            setOpenSelector(constants/* LEASE_PROFILE_FILTER_TERMS */.m$);
            if (setOpenSelectorOverride) {
                setOpenSelectorOverride(constants/* LEASE_PROFILE_FILTER_TERMS */.m$);
            }
            document.querySelector("header").classList.add("overlay-open");
            (0,vehicle/* addToDataLayer */.Bk)({
                event: "lease-profile-filter",
                "filter-event": "open",
                experimentGroup: experimentGroup
            });
            dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
                event: constants/* constants.eventTypes.leaseProfileFilter */._G.eventTypes.leaseProfileFilter,
                payload: {
                    "filter-event": "open"
                }
            }));
        }
    };
    var masterOpenSelector = context === "config" || context === "ad" ? openSelectorOverride : openSelector;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((profile_editor_module_default()).overlay, " ").concat(masterOpenSelector === "" ? (profile_editor_module_default()).closed : (profile_editor_module_default()).open),
                onClick: closeSelector
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((profile_editor_module_default()).wrapper, " ").concat(version !== "control" ? (profile_editor_module_default()).variant : "", " ").concat(masterOpenSelector === "" ? (profile_editor_module_default()).closed : (profile_editor_module_default()).open),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((profile_editor_module_default())["button-group"], " ").concat((profile_editor_module_default())["top-level"]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: "".concat((profile_editor_module_default())["toggle-button"], " ").concat(masterOpenSelector === constants/* LEASE_PROFILE_FILTER_TERMS */.m$ ? (profile_editor_module_default()).active : ""),
                                onClick: function() {
                                    return onToggleSelector(constants/* LEASE_PROFILE_FILTER_TERMS */.m$);
                                },
                                children: [
                                    "".concat((0,search/* getTermsAsYearsName */.B5)(leaseProfile.term), " yr").concat(leaseProfile.term !== 12 ? "s" : "", " + ").concat(leaseProfile.initialPaymentInMonths, " mo").concat(leaseProfile.initialPaymentInMonths > 1 ? "s" : "", " upfront"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            ", ",
                                            leaseProfile.mileage / 1000,
                                            "k miles,",
                                            leaseProfile.leaseType === constants/* FILTER_LEASE_TYPES_BUSINESS */.kG ? "Business" : "Personal",
                                            ",",
                                            leaseProfile.stockStatus === constants/* FILTER_STOCK_STATUS_IN_STOCK */.Wx ? " In stock" : " Factory order"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((profile_editor_module_default())["vertical-line"], " ").concat(masterOpenSelector === constants/* LEASE_PROFILE_FILTER_MILEAGES */.zK || masterOpenSelector === constants/* LEASE_PROFILE_FILTER_TERMS */.m$ ? (profile_editor_module_default()).white : "")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: "".concat((profile_editor_module_default())["toggle-button"], " ").concat(masterOpenSelector === constants/* LEASE_PROFILE_FILTER_MILEAGES */.zK ? (profile_editor_module_default()).active : ""),
                                onClick: function() {
                                    return onToggleSelector(constants/* LEASE_PROFILE_FILTER_MILEAGES */.zK);
                                },
                                children: [
                                    (0,search/* formatWithCommas */.b1)(leaseProfile.mileage),
                                    " miles"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((profile_editor_module_default())["vertical-line"], " ").concat(masterOpenSelector === constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt || masterOpenSelector === constants/* LEASE_PROFILE_FILTER_MILEAGES */.zK ? (profile_editor_module_default()).white : "")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: "".concat((profile_editor_module_default())["toggle-button"], " ").concat(masterOpenSelector === constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt ? (profile_editor_module_default()).active : ""),
                                onClick: function() {
                                    return onToggleSelector(constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt);
                                },
                                children: [
                                    leaseProfile.leaseType === constants/* FILTER_LEASE_TYPES_BUSINESS */.kG ? "Business" : "Personal",
                                    ",",
                                    leaseProfile.stockStatus === constants/* FILTER_STOCK_STATUS_IN_STOCK */.Wx ? " In stock" : " Factory order"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                className: "".concat((profile_editor_module_default())["edit-button"]).concat(!(0,system/* isProd */.BB)() ? " profile-editor__edit-button" : ""),
                                onClick: onToggleEdit,
                                label: masterOpenSelector ? "Close" : "Edit",
                                icon: masterOpenSelector ? "X" : "SlidersHorizontal",
                                size: types_system/* Size.Small */.$u.Small,
                                hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (profile_editor_module_default())["dropdown-wrapper"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                id: "lease-profile-type",
                                duration: 300,
                                height: masterOpenSelector === constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt ? "auto" : 0,
                                delay: masterOpenSelector === constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt ? 450 : 0,
                                animateOpacity: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (profile_editor_module_default()).dropdown,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (profile_editor_module_default()).inner,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Type of lease"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((profile_editor_module_default())["button-group"], " ").concat((profile_editor_module_default())["connected-buttons"]),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        type: "button",
                                                        className: "".concat(leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (profile_editor_module_default()).active : "").concat(!(0,system/* isProd */.BB)() ? " profile-editor__lease-type-button--personal" : ""),
                                                        onClick: function() {
                                                            setLeaseType(constants/* FILTER_LEASE_TYPES_PERSONAL */.m_);
                                                            onChangeParameter(constants/* LEASE_PROFILE_FILTER_LEASE_TYPE */.Rb, constants/* FILTER_LEASE_TYPES_PERSONAL */.m_);
                                                        },
                                                        disabled: !(0,vehicle/* isLeaseProfileOptionAvailable */.nu)(availableFilters, "leaseTypes", constants/* FILTER_LEASE_TYPES_PERSONAL */.m_),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Personal"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "Incl VAT"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        type: "button",
                                                        className: "".concat(leaseType === constants/* FILTER_LEASE_TYPES_BUSINESS */.kG ? (profile_editor_module_default()).active : "").concat(!(0,system/* isProd */.BB)() ? " profile-editor__lease-type-button--business" : ""),
                                                        onClick: function() {
                                                            setLeaseType(constants/* FILTER_LEASE_TYPES_BUSINESS */.kG);
                                                            onChangeParameter(constants/* LEASE_PROFILE_FILTER_LEASE_TYPE */.Rb, constants/* FILTER_LEASE_TYPES_BUSINESS */.kG);
                                                        },
                                                        disabled: !(0,vehicle/* isLeaseProfileOptionAvailable */.nu)(availableFilters, "leaseTypes", constants/* FILTER_LEASE_TYPES_BUSINESS */.kG),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Business"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "Excl VAT"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (profile_editor_module_default()).paragraph,
                                                children: leaseType === constants/* FILTER_LEASE_TYPES_BUSINESS */.kG ? "Lease your next company ".concat(vehicleType === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz ? "van" : "car", ". All deals come with manufacturer's warranty, road tax and exclude VAT.") : "Lease your next ".concat(vehicleType === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz ? "van" : "car", " for yourself. All deals come with manufacturer's warranty and road tax as standard.")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Stock status"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((profile_editor_module_default())["button-group"], " ").concat((profile_editor_module_default()).padding),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorButton/* SelectorButton */.P, {
                                                        onChangeParameter: function() {
                                                            setStockStatus(constants/* FILTER_STOCK_STATUS_IN_STOCK */.Wx);
                                                            onChangeParameter(constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt, constants/* FILTER_STOCK_STATUS_IN_STOCK */.Wx);
                                                        },
                                                        filter: constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt,
                                                        filterValue: constants/* FILTER_STOCK_STATUS_IN_STOCK */.Wx,
                                                        activeValue: stockStatus,
                                                        availableFilters: availableFilters
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorButton/* SelectorButton */.P, {
                                                        onChangeParameter: function() {
                                                            setStockStatus(constants/* FILTER_STOCK_STATUS_FACTORY_ORDER */.Cm);
                                                            onChangeParameter(constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt, constants/* FILTER_STOCK_STATUS_FACTORY_ORDER */.Cm);
                                                        },
                                                        filter: constants/* LEASE_PROFILE_FILTER_STOCK_STATUS */.nt,
                                                        filterValue: constants/* FILTER_STOCK_STATUS_FACTORY_ORDER */.Cm,
                                                        activeValue: stockStatus,
                                                        availableFilters: availableFilters
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                id: "lease-profile-price",
                                duration: 300,
                                delay: masterOpenSelector === constants/* LEASE_PROFILE_FILTER_TERMS */.m$ ? 450 : 0,
                                height: masterOpenSelector === constants/* LEASE_PROFILE_FILTER_TERMS */.m$ ? "auto" : 0,
                                animateOpacity: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (profile_editor_module_default()).dropdown,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (profile_editor_module_default()).inner,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Terms, {
                                                term: term,
                                                onChangeTerm: onChangeTerm,
                                                availableFilters: availableFilters
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialPaymentInMonths, {
                                                initialPaymentInMonths: initialPaymentInMonths,
                                                onChangeInitialPayment: onChangeInitialPayment,
                                                availableFilters: availableFilters
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (profile_editor_module_default()).paragraph,
                                                children: "Your upfront payment is your first month's payment. The higher your upfront payment the cheaper your monthly payments will be."
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                id: "lease-profile-mileage",
                                duration: 300,
                                delay: masterOpenSelector === constants/* LEASE_PROFILE_FILTER_MILEAGES */.zK ? 450 : 0,
                                height: masterOpenSelector === constants/* LEASE_PROFILE_FILTER_MILEAGES */.zK ? "auto" : 0,
                                animateOpacity: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (profile_editor_module_default()).dropdown,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (profile_editor_module_default()).inner,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Miles per annum"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((profile_editor_module_default())["button-group"], " ").concat((profile_editor_module_default()).stacked),
                                                children: constants/* LEASE_PROFILE_FILTER_MILEAGES_VALUES.map */.lP.map(function(value) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorButton/* SelectorButton */.P, {
                                                        onChangeParameter: onChangeMileage,
                                                        filter: constants/* LEASE_PROFILE_FILTER_MILEAGES */.zK,
                                                        filterValue: value,
                                                        activeValue: mileage,
                                                        availableFilters: availableFilters
                                                    }, value);
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/views/ProfileEditor/index.js



/***/ }),

/***/ 5958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ selectLeaseProfile; },
/* harmony export */   "o": function() { return /* binding */ selectAvailableLeaseProfileFilters; }
/* harmony export */ });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

var getLeaseProfile = function(state) {
    return state.leaseProfile;
};
var selectAvailableLeaseProfileFilters = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getLeaseProfile
], function(leaseProfile) {
    return leaseProfile.availableProfiles;
});
var selectLeaseProfile = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getLeaseProfile
], function(leaseProfile) {
    return leaseProfile.activeProfile;
});


/***/ }),

/***/ 20548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ID": function() { return /* binding */ selectVehicleForPaintOption; },
/* harmony export */   "KL": function() { return /* binding */ selectSelectedVehiclePaintOption; },
/* harmony export */   "eJ": function() { return /* binding */ selectPaintOptions; },
/* harmony export */   "h2": function() { return /* binding */ selectVehicleImages; }
/* harmony export */ });
/* unused harmony export getVehicle */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69779);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);


var getVehicle = function(state) {
    return state.vehicle;
};
var selectVehicleImages = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getVehicle
], function(vehicle) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(vehicle.exteriorImages || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(vehicle.interiorImages || []));
});
var selectSelectedVehiclePaintOption = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getVehicle
], function(vehicle) {
    return vehicle.selectedPaintOption;
});
var selectPaintOptions = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getVehicle
], function(vehicle) {
    return vehicle.paintOptions;
});
var selectVehicleForPaintOption = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getVehicle
], function(vehicle) {
    return vehicle.paintOptionVehicle;
});


/***/ }),

/***/ 79197:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"large-button":"selector-button_large-button__z5FNT","active":"selector-button_active__luxua","small-text":"selector-button_small-text__XdRZR","score":"selector-button_score__r9_A8","phAnimation":"selector-button_phAnimation__pIppf"};

/***/ }),

/***/ 53644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"score":"loco-score_score___FxZc","ring":"loco-score_ring__zuCKC","container":"loco-score_container__p90CW","text":"loco-score_text__w_aMB","title":"loco-score_title__zoTzI","description":"loco-score_description__MfcQu","phAnimation":"loco-score_phAnimation__ElO02"};

/***/ }),

/***/ 80001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reverse-image":"vehicle-image_reverse-image__uOgl_","padded-image":"vehicle-image_padded-image__sESfX","wrapper":"vehicle-image_wrapper__zluzR","arrows":"vehicle-image_arrows__4kG9G","dots":"vehicle-image_dots__RtU0B","dot":"vehicle-image_dot__bxknn","close":"vehicle-image_close__agwhd","far":"vehicle-image_far___i7DM","too-far":"vehicle-image_too-far__Mglyo","active":"vehicle-image_active__a6CKC","carousel":"vehicle-image_carousel__kVC1q","item":"vehicle-image_item__XBP0m","content":"vehicle-image_content__qHmo1","spec-image":"vehicle-image_spec-image__EEsLS","phAnimation":"vehicle-image_phAnimation__X2gd8"};

/***/ }),

/***/ 26449:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"profile-editor_overlay__OM4bC","open":"profile-editor_open__K42U_","closed":"profile-editor_closed__DF7sA","variant":"profile-editor_variant__LV0s3","wrapper":"profile-editor_wrapper__ThNhh","container":"profile-editor_container__V_ixs","section":"profile-editor_section__JrK0I","sheet":"profile-editor_sheet__S2eWF","slider-left":"profile-editor_slider-left____gep","slider-right":"profile-editor_slider-right__KuEqE","button-group":"profile-editor_button-group__O_q_8","vertical-line":"profile-editor_vertical-line__eP1NG","white":"profile-editor_white__n6p_5","toggle-button":"profile-editor_toggle-button__u1CEb","active":"profile-editor_active__iW3Dy","top-level":"profile-editor_top-level__JDJEe","dropdown":"profile-editor_dropdown__ef8IY","small-width":"profile-editor_small-width__ZVfU7","inner":"profile-editor_inner__imJKb","paragraph":"profile-editor_paragraph__4vYgg","stacked":"profile-editor_stacked__nNuf6","padding":"profile-editor_padding__6CvJl","button":"profile-editor_button__zq3Fb","connected-buttons":"profile-editor_connected-buttons__5_3pc","sheet-footer":"profile-editor_sheet-footer__mQkjR","details":"profile-editor_details__HhS39","price":"profile-editor_price__pkZtA","profile":"profile-editor_profile__frk1F","incentives":"profile-editor_incentives__dFzS0","text":"profile-editor_text___L7tm","tabs":"profile-editor_tabs__t6CK7","sections":"profile-editor_sections__M0lhV","title":"profile-editor_title__LsUqF","mileage":"profile-editor_mileage__xKOvl","stock-status":"profile-editor_stock-status__TOl2m","lease-type":"profile-editor_lease-type__WYRpd","scroll-area":"profile-editor_scroll-area__mJYY_","large-button":"profile-editor_large-button__uj_WY","scroll-group":"profile-editor_scroll-group__T_pvZ","slider-button":"profile-editor_slider-button__yrJzH","editor-control-bar":"profile-editor_editor-control-bar__VONqi","black-btn":"profile-editor_black-btn__fKyDw","phAnimation":"profile-editor_phAnimation__iKUEf"};

/***/ })

}]);